import {
   
    GET_RCREPORTS_STARTED,
   
    GET_RCREPORTS_COMPLETED,
    GET_RCREPORTS_FAILED,
    GET_REFRESH_STARTED,
    GET_REFRESH_COMPLETED,
    GET_REFRESH_FAILED

} from '../actions/Rcreports';

const intialRCREPORTSData= {
    status: {
        statusCode: 300,
        statusDisplay: "",
        statusValue: true
    },
    items: [],
    userInput: {       
        insert_datetime:"",
        inserted_by:"",
        update_datetime:"",
        updated_by:""
    
    },
    isLoading: true,
    isFormSubmit: false,
    isLoggedIn: false,
    error: ''
};
export const RCREPORTSData = (state = intialRCREPORTSData, action: any) => {
    
 
    switch (action.type) {
        case GET_RCREPORTS_STARTED:          
      return {
        ...state,
        items:[],
        isLoading: true,
      };
    case GET_RCREPORTS_COMPLETED:
      return {
        ...state,
        isLoading: false,
        status: action.status,
        items: action.payload
      };
    case GET_RCREPORTS_FAILED:
      return {
        ...state,
        isLoading: true,
      };
      case GET_REFRESH_STARTED:          
      return {
        ...state,
        items:[],
        isLoading: true,
      };
    case GET_REFRESH_COMPLETED:
      return {
        ...state,
        isLoading: false,
        status: action.status,
        items: action.payload
      };
    case GET_REFRESH_FAILED:
      return {
        ...state,
        isLoading: true,
      };

        default:
            return state;
    }
};